export default "__VITE_ASSET__DHmYjm6J__"